import { NavLink } from "react-router-dom";
import { Package, Award, Receipt, FileText, BarChart3, Settings } from "lucide-react";
import { cn } from "../lib/utils";

const navItems = [
  { path: "/", label: "Inventory", icon: Package },
  { path: "/grading", label: "Grading", icon: Award },
  { path: "/expenses", label: "Expenses", icon: Receipt },
  { path: "/tax-center", label: "Tax Center", icon: FileText },
  { path: "/reporting", label: "Reporting", icon: BarChart3 },
  { path: "/settings", label: "Settings", icon: Settings },
];

export const Navigation = () => {
  return (
    <nav className="border-b bg-card">
      <div className="container">
        <div className="flex gap-1 overflow-x-auto">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path !== "/reporting"}
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-2 px-4 py-3 text-sm font-medium transition-colors relative",
                    "hover:text-primary",
                    isActive
                      ? "text-primary after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-gradient-primary"
                      : "text-muted-foreground"
                  )
                }
              >
                <Icon className="h-4 w-4" />
                <span className="whitespace-nowrap">{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      </div>
    </nav>
  );
};